// extracted by mini-css-extract-plugin
module.exports = {"container":"animated_link-module--container--392ag","icon":"animated_link-module--icon--2XSA4","title":"animated_link-module--title--1U89H"};